import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface CampWorkflowJobDoneNotifyFollowerProps extends BaseTemplateProps {
  stepName: string
  successfulCount: number
  failedCount: number
  unknownCount: number
  stepLink: string
}

export const CampWorkflowJobDoneNotifyFollower: TemplateDefinition<CampWorkflowJobDoneNotifyFollowerProps> =
  {
    renderParams: (props: CampWorkflowJobDoneNotifyFollowerProps) => ({
      messageKey: 'notificationsDomain.templates.campWorkflowJobDoneNotifyFollower',
      values: {
        stepName: props.stepName,
        successfulCount: props.successfulCount,
        failedCount: props.failedCount,
        unknownCount: props.unknownCount,
      },
    }),
    getLink: (props: CampWorkflowJobDoneNotifyFollowerProps): string => props?.stepLink || '',
  }
